import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { CategoryService } from '../../services/category.service';
import { Category } from 'src/app/models/category/category.module';
import { RouterModule, Router, ActivatedRoute, Params } from '@angular/router';

import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  agregar_proyecto: boolean = false;
  categoria: Array<Category>;
  cat: Category;
  edit_cat: Category;
  token;
  identity;
  status: string;
  message: string;
  loading: boolean = false;
  loading_edit: boolean = false;
  id_us: number;
  cargando: boolean = false;
  cat_edit: string;
  id_edit: number;
  color_edit: string;

  constructor(private _userService: UserService, private _categoryService: CategoryService, public router: Router) {
    this.cargando = true;
    this.identity = this._userService.getIdentity();


    if (this.identity == null) {
      this.router.navigate(["/login"]);
    }

    let user = this._userService.getIdentity();
    let token = this._userService.getToken();
    this.verProyectos(user.sub, token);
    this.id_us = user.sub;
    this.cat = new Category(1, '', user.sub, '#007bff', '', 0);
    this.edit_cat = new Category(1, '', user.sub, '#007bff', '', 0);
    this.token = token;
  }

  ngOnInit(): void {

  }
  verform() {
    // console.log('click');
    this.agregar_proyecto = true;
  }
  cerrarform() {
    this.agregar_proyecto = false;
  }
  verProyectos(id, token) {

    this._categoryService.getCat(id, token).subscribe(
      response => {

        if (response.status == 'success') {
          this.cargando = false;
          this.categoria = response.array;
        } else {
          //console.log(response);
          localStorage.removeItem('identity');
          localStorage.removeItem('token');
          this.identity = null;
          this.token = null;
          this.router.navigate(["/login"]);
        }
      }, error => {
        this.message = "Ocurrio un error, Actualize el navegador";
        console.log(error);
      }
    );
  }

  onSubmit(form) {
    //console.log(this.cat);
    this.loading = true;
    this._categoryService.add_category(this.cat, this.token).subscribe(
      response => {
        // Token
        if (response.status != 'error') {

          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: response.message,
            showConfirmButton: false,
            timer: 1500
          })
          this.status = 'success';
          this.loading = false;
          this.verProyectos(this.id_us, this.token);
          this.cat = new Category(1, '', this.id_us, '#007bff', '', 0);
          form.reset();
        } else {
          this.status = 'error';
          console.log("error");
          this.loading = false;
        }
      }, error => {
        this.status = 'error';
        console.log(<any>error);
        this.loading = false;
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );
  }

  edit_cat_table(cat_edit: Category) {
    // console.log(cat_edit);
    this.cat_edit = cat_edit.categoria;
    this.edit_cat.id = cat_edit.id;
    this.color_edit = cat_edit.color;
    this.edit_cat = new Category(cat_edit.id, cat_edit.categoria, 0, cat_edit.color, '', 0);
    $('#exampleModal').modal('show');
  }
  onSubmitEdit(form) {
    this.loading_edit = true;
    //console.log(this.edit_cat);
    this._categoryService.ed_category(this.edit_cat, this.token).subscribe(
      response => {
        // Token
        // console.log(response);
        if (response.status != 'error') {
          this.verProyectos(this.id_us, this.token);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: response.message,
            showConfirmButton: false,
            timer: 1500
          })
          this.loading_edit = false;
          this.edit_cat = new Category(1, '', 0, '#007bff', '', 0);
          form.reset();
          $('#exampleModal').modal('hide');
        } else {
          console.log("error");
          this.loading_edit = false;
        }
      },
      error => {
        console.log(<any>error);
        this.loading = false;
      }
    );
  }
  del_cat_table(cat: Category) {
    // console.log(cat);
    Swal.fire({
      title: '¿Eliminar el Proyecto?',
      text: "Desea eliminar el proyecto",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {


        this._categoryService.del_category(cat, this.token).subscribe(
          response => {
            // Token
            // console.log(response);
            if (response.status != 'error') {
              this.verProyectos(this.id_us, this.token);
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: response.message,
                showConfirmButton: false,
                timer: 1500
              });
            } else {
              console.log("error");
            }
          },
          error => {
            console.log(<any>error);
          }
        );




      }
    })

  }


  verActividades(cat) {
    //this.router.navigate(['/actividades', {outlets: {'cat': [cat]}}]);
    this._categoryService.category = cat;
    this.router.navigateByUrl('/actividades');
  }


}
